import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import React from 'react';

const NewViewListButton = (props) => {
	const { t, label, onLabelChange, onSubmit, isValid, color } = props;
	const [isAddingView, setIsAddingView] = React.useState(false);
	
	const handleSubmitForm = (event) => {
		onSubmit();
		setIsAddingView(false);
		event.preventDefault();
	};
	return (
		<React.Fragment>
			<Button
				color={color}
				endIcon={<AddIcon/>}
				size="small"
				onClick={() => setIsAddingView(true)}
			>
				{t('Save current view')}
			</Button>
			<Dialog onClose={() => setIsAddingView(false)} open={isAddingView}>
				<form onSubmit={handleSubmitForm}>
					<DialogTitle>{t('New custom view')}</DialogTitle>
					<DialogContent>
						<TextField
							autoFocus
							value={label}
							onChange={onLabelChange}
							margin="dense"
							size="small"
							label={t('Custom view label')}
							variant="standard"
							fullWidth
						/>
					</DialogContent>
					<DialogActions>
						<Button type="button" onClick={() => setIsAddingView(false)}>
							{t('Cancel')}
						</Button>
						<Button type="submit" disabled={!isValid}>
							{t('Create view')}
						</Button>
					</DialogActions>
				</form>
			</Dialog>
		</React.Fragment>
	);
};

export default NewViewListButton